module.exports = __webpack_public_path__ + "static/media/LIQ.d62bc235.png";